import React, { useEffect, useState } from 'react'
import { FaVideoSlash } from 'react-icons/fa'
import RecentBallResults from '../components/RecentBallResults'
import LiveBattingTable from '../components/LiveBattingTable'
import TeamScores from '../components/TeamScores'
import './Cartoons.scss'
import BallResults from '../BallResults.json'

const virtualGameTypes = ["QUANTUM", "VRKBD", "VRFTB", "VRHOM", "VRBHT"]

const Clip = ({ clip, overlayText, layout, gameType, fullscreenCartoon, cartoonOnly }) => {
    const [clips, setClips] = useState([])
    const [activeClipName, setActiveClipName] = useState(null)

    const videoRef = React.useRef(null)

    useEffect(() => {
        let clipsSplit = clip.split(', ')
        setClips(clipsSplit)
        setActiveClipName(clipsSplit[0])
    }, [clip])

    useEffect(() => {
        const videoPlayer = videoRef.current
        videoPlayer.loop = false
        
        function clipEnded(e) {
            const currentClipIndex = clips.findIndex(name => name === activeClipName)
            const newClipIndex = currentClipIndex + 1

            if (clips[newClipIndex]) {
                setActiveClipName(clips[newClipIndex])
                videoPlayer.play()
            } else {
                videoPlayer.pause()
            }
        }

        videoPlayer.addEventListener('ended', clipEnded)

        return () => {
            videoPlayer.removeEventListener('ended', clipEnded)
        }
    }, [clips, activeClipName])

    const showOverlay = Boolean(overlayText && videoRef.current &&
        (activeClipName.includes('crowd') || activeClipName.includes('endgame')))

    return (
        <>
            <div className="overlay">
                { showOverlay && overlayText.length > 2 ? (
                    <div className="text">
                        {overlayText}
                    </div>
                ) : showOverlay ? (
                    <>
                        <div className="text">
                            {overlayText[0]}
                        </div>
                        <div className="text">
                            {overlayText[1]}
                        </div>
                    </>
                ) : null}
            </div>
            <video 
                src={`https://videos.decimalcricket.net/QCR/${activeClipName}`} 
                playsInline={true}
                webkit-playsinline="true"
                muted={true} // Chrome does not allow autoplay with sound
                autoPlay={true}
                width="100%"
                type="video/mp4"
                ref={videoRef}
                style={{ 
                    maxHeight: layout === 'single' && ! fullscreenCartoon && ! cartoonOnly ? '210px' : null,
                    paddingBottom: gameType === 'QUANTUM' ? '15px' : null, 
                 }}
            />
        </>
    )
}

export default function Cartoons({ clip, layout, teams, event, scorecard, scoregrid, scoreboard, backgroundColor, gameType, isHundred, fullscreenCartoon, cartoonOnly, teamFontSize, domain }) {
    if (!scorecard && gameType !== 'KABD') {
        return null
    }
    const { event_status } = scorecard

    let complete = false

    if (event_status.includes('Match Complete')) {
        complete = true
    }

    const { overs } = scoregrid || {};

    const { inns1, inns2, inns3, inns4 } = overs || {};

    let recentOvers = [];

    if (inns1){
        inns1.forEach(over => {
            let balls = []

            for (let i = 1; i <= 12; i++) {
                if (over['b' + i]) {
                    balls.unshift(over['b' + i]);
                }
            }

            recentOvers.unshift({
                over: over.ov,
                balls
            })
        })
    }

    if (inns2){
        inns2.forEach(over => {
            let balls = []

            for (let i = 1; i <= 12; i++) {
                if (over['b' + i]) {
                    balls.unshift(over['b' + i]);
                }
            }

            recentOvers.unshift({
                over: over.ov,
                balls
            })
        })
    }

    if (inns3){
        inns3.forEach(over => {
            let balls = []

            for (let i = 1; i <= 12; i++) {
                if (over['b' + i]) {
                    balls.unshift(over['b' + i]);
                }
            }

            recentOvers.unshift({
                over: over.ov,
                balls
            })
        })
    }

    if (inns4){
        inns4.forEach(over => {
            let balls = []

            for (let i = 1; i <= 12; i++) {
                if (over['b' + i]) {
                    balls.unshift(over['b' + i]);
                }
            }

            recentOvers.unshift({
                over: over.ov,
                balls
            })
        })
    }

    function getResultDescription(ball) {
        if (! ball) {
            return null
        }

        ball = ball.toLowerCase()
        const result = BallResults[ball]

        if (! result) {
            return null
        }

        return result.description.toUpperCase()
    }

    let overlayText = null;

    if (complete) {
        overlayText = event_status.replace('Match Complete -', '').replace('(V)', '(V)\n').split('\n')
        clip = "endgame.mp4"
    } else if (recentOvers && recentOvers.length) {
        overlayText = getResultDescription(recentOvers[0].balls[0])
    }

    return (
        <div className="cartoons" style={{ 
            backgroundColor, 
            display: layout === 'double' ? 'flex' : 'block',
         }}>
            { layout === 'single' && ! fullscreenCartoon && ! cartoonOnly && (
                <>
                    <TeamScores
                        teams={teams}
                        event={event}
                        scoreboard={scoreboard}
                        isHundred={isHundred}
                        teamFontSize={teamFontSize}
                    />
                    {virtualGameTypes.includes(gameType) && !domain?.includes('intelligentcricket') && (
                        <a className="intelligent-link" rel="noreferrer" target="_blank" href="https://intelligentcricket.com/games">View results @ intelligentcricket.com/games</a>
                    )}
                    <LiveBattingTable scoreboard={scoreboard} />
                </>
            ) }

            { clip ? ( 
                <div 
                    className="video-wrapper"
                    style={{
                        display: layout === 'double' ? 'flex' : 'block'
                    }}
                >
                    <Clip 
                        clip={clip} 
                        overlayText={overlayText} 
                        layout={layout} 
                        gameType={gameType}
                        fullscreenCartoon={fullscreenCartoon}
                        cartoonOnly={cartoonOnly}
                    />
                    { layout === 'single' && ! fullscreenCartoon && ! cartoonOnly && (
                        <RecentBallResults
                            scoregrid={scoregrid}
                        />
                    )}
                </div>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', color: 'white'}}>
                    <div style={{ textAlign: 'center'}}>
                        <FaVideoSlash size={25}/>
                        <div>No video clip</div>
                    </div>
                </div>
            )}
            
        </div>
    )
}
